export const SETTINGS_CARD_HEADING_PREFIX = "settings-card-heading-";
